<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableData"
      style="width: 100.1%"
    ></Table>
    <br />
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
let self = {};
export default {
  name: "TableElasticComputeCloudResourceHwc",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      columns: [
        {
          title: this.$t("RAM.HWC.ECS.accountID"),
          key: "accountIdString",
        },
        {
          title: this.$t("RAM.HWC.ECS.accountName"),
          key: "accountName",
        },
        {
          title: this.$t("RAM.HWC.ECS.region"),
          key: "region",
        },
        {
          title: this.$t("RAM.HWC.OBS.bucketName"),
          key: "name",
        },
        {
          title: this.$t("RAM.HWC.OBS.storageType"),
          key: "storageClass",
        },
        {
          title: this.$t("RAM.HWC.OBS.bucketStorage"),
          key: "bucketStorage",
        },
        {
          title: this.$t("RAM.HWC.OBS.objectCount"),
          key: "objectNumber",
        },
        {
          title: this.$t("RAM.HWC.OBS.createTime"),
          key: "creationDateString",
        },
      ],
      tableData: [],
    };
  },
  created() {
    // 获取搜索内容
    eventBus.$on("companyId", (val) => {
      this.companyId = val;
    });
    eventBus.$on("accountName", (val) => {
      this.accountName = val;
    });
    eventBus.$on("name", (val) => {
      this.name = val;
    });
    eventBus.$on("accountSearchKey", (val) => {
      this.accountSearchKey = val;
    });
    self = this;
  },
  methods: {
    showAll() {
      self.getData();
    },
    // 分页显示数据
    /****************************************************/
    getData() {
      self.$api.resourceManagement
        .selectHWCBucketByPage({
          companyId: self.companyId,
          accountName: self.accountName,
          name: self.name,
          accountIds: self.accountSearchKey,
          pageNum: self.current,
          pageSize: self.pageSize,
        })
        .then((res) => {
          this.tableData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage(current) {
      this.current = current;
      this.getData();
    },
    changeSize(pageSize) {
      this.pageSize = pageSize;
      this.getData();
    },
    // 销毁
    beforeDestroy() {
      eventBus.$off("companyId");
      eventBus.$off("accountName");
      eventBus.$off("name");
      eventBus.$off("accountSearchKey");
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/hwc/obs/TableObjectStorageHwc.vue